import { useState, useCallback } from 'react';
import { getItem, setItem as storageSetItem } from './storage';

const useLocalStorage = (key, initialValue) => {
  const [storedValue, setStoredValue] = useState(() => getItem(key) ?? initialValue);

  const setValue = useCallback(
    (value) => {
      const valueToStore = typeof value === 'function' ? value(storedValue) : value;
      setStoredValue(valueToStore);
      storageSetItem(key, valueToStore);
    },
    [key, storedValue],
  );

  return [storedValue, setValue];
};

export default useLocalStorage;
